function pad2(value: number): string {
  return String(value).padStart(2, '0');
}

function packTime(hour: number, minute: number): string | null {
  if (
    !Number.isInteger(hour)
    || !Number.isInteger(minute)
    || hour < 0
    || hour > 23
    || minute < 0
    || minute > 59
  ) {
    return null;
  }
  return `${pad2(hour)}:${pad2(minute)}`;
}

/** Normalize a typed 24-hour draft to `HH:mm`, or null if it is not a clock time. */
export function normalizeScheduleTime(raw: string): string | null {
  const trimmed = raw.trim().replace(/\s+/g, '');
  if (!trimmed) return null;

  const separated = /^(\d{1,2})[:.hH](\d{1,2})$/.exec(trimmed);
  if (separated) return packTime(Number(separated[1]), Number(separated[2]));

  if (!/^\d{1,4}$/.test(trimmed)) return null;
  if (trimmed.length <= 2) return packTime(Number(trimmed), 0);
  if (trimmed.length === 3) return packTime(Number(trimmed[0]), Number(trimmed.slice(1)));
  return packTime(Number(trimmed.slice(0, 2)), Number(trimmed.slice(2)));
}

export function shiftScheduleTime(time: string, deltaMinutes: number): string {
  const normalized = normalizeScheduleTime(time) ?? '00:00';
  const [hour, minute] = normalized.split(':').map(Number);
  const dayMinutes = 24 * 60;
  const next = ((hour * 60 + minute + deltaMinutes) % dayMinutes + dayMinutes) % dayMinutes;
  return `${pad2(Math.floor(next / 60))}:${pad2(next % 60)}`;
}
